import { isMotionValue } from "../../external/.pnpm/motion-dom@12.22.0/external/motion-dom/dist/es/value/utils/is-motion-value.mjs";
function isWillChangeMotionValue(value) {
  return Boolean(isMotionValue(value) && value.add);
}
export {
  isWillChangeMotionValue
};
